import emojiToolkit from "emoji-toolkit";

export const EMOJI_ENTITY_TYPE = "emoji";
export const EMOJI_ENTITY_MUTABILITY = "IMMUTABLE";

export const REGEX_EMOJI_UNICODE = new RegExp(emojiToolkit.regUnicode, "g");
export const REGEX_EMOJI_TEST = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/;
